/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EvmAddressTokenHoldingListInfo } from '../models/EvmAddressTokenHoldingListInfo';
import type { EvmAddressTokenHoldingListRequest } from '../models/EvmAddressTokenHoldingListRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class KiteService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getErc721HoldingList({
        requestBody,
    }: {
        requestBody: EvmAddressTokenHoldingListRequest,
    }): CancelablePromise<EvmAddressTokenHoldingListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/address/token/erc721/holding/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getErc20HoldingList({
        requestBody,
    }: {
        requestBody: EvmAddressTokenHoldingListRequest,
    }): CancelablePromise<EvmAddressTokenHoldingListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/address/token/erc20/holding/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getErc1155HoldingList({
        requestBody,
    }: {
        requestBody: EvmAddressTokenHoldingListRequest,
    }): CancelablePromise<EvmAddressTokenHoldingListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/address/token/erc1155/holding/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
